export default "__VITE_ASSET__C$w1VX9i__"